import { render, staticRenderFns } from "./articleHomeDetail.vue?vue&type=template&id=2da9b5d6&scoped=true"
import script from "./articleHomeDetail.vue?vue&type=script&lang=js"
export * from "./articleHomeDetail.vue?vue&type=script&lang=js"
import style0 from "./articleHomeDetail.vue?vue&type=style&index=0&id=2da9b5d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da9b5d6",
  null
  
)

export default component.exports